import type { ApiConfig } from '../../types'

export const spotTradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: (730 * 24 - 1) * 60 * 60 * 1000, // 2 years
  limit: 100,
  order: 'desc',
  range: 7 * 24 * 60 * 60 * 1000, // 7 days
  requiresRange: true,
  type: 'spot-trade-history',
} as const satisfies ApiConfig
